<div class="container-fluid" style="max-width: inherit;">
  <span>
    @if (this.user && isStatusOk(this.user.roles, null, 'ASSIGN')) {
      <button class="btn btn-outline-primary" style="margin-bottom: 10px;"
        (click)="openModalAssign(templateTeam, null, 'ASSIGN')">{{'CONTROL-MODULE.EDIT_TEAM' |
      translate}}</button>
    }
  </span>
  <div ngbAccordion style="max-width: inherit;" >
    @for (task of step.tasks; track task) {
      <div [ngbAccordionItem]="task.key" id="{{task.key}}" [collapsed]="task.key != activeTaskKey">
        <h2 ngbAccordionHeader>
          <div class="d-flex align-items-center justify-content-between">
            @if (this.user && isStatusOk(this.user.roles, task, 'ASSIGN')) {
              <button class="btn btn-outline-primary"
                (click)="openModalAssign(templateTeam, task.key, 'ASSIGN')">{{'CONTROL-MODULE.ASSIGN_TEAM' |
              translate}}</button>
            }
            @if (this.user && (task.status!=='DRAFT' || task.mode === 'SAVABLE_WHEN_NOT_ACTIVE' || this.user.roles.includes('CONTROLLER') ||  this.user.roles.includes('CHEF') ||
              this.user.roles.includes('COORDINATOR') || this.user.roles.includes('DIRECTOR_GENERAL') || this.user.roles.includes('DIRECTOR_APPROVER'))) {
              <button ngbAccordionToggle type="button" class="btn btn-link" style="width: 75%;"
                >
                <div class="d-flex flex-row p-1">
                  {{task.name}}
                </div>
                <div class="d-flex p-1 text-muted">
                  <small [ngClass]="task.status.toLocaleLowerCase()">{{'CONTROL-MODULE.'+task.status | translate}}
                    @if (task.status==='SUSPEND_REQUEST') {
                      <span>
                        {{task.suspendExtendDays}} {{'CONTROL-MODULE.SUSPEND_DAY(S)' | translate}}
                      </span>
                    }
                  </small>
                </div>
              </button>
            }
            @if (task.deadLine) {
              <div class="d-flex justify-content-between align-items-center">
                <img src="assets/img/alert.png" style="height: 27px; width: 32px; margin-right:5px;">
                <small
                  [ngClass]="(task.status==='ONGOING' || task.status==='DRAFT' || task.status==='SUSPEND_REQUEST')?'task.status.toLocaleLowerCase() deadline-task':'task.status.toLocaleLowerCase() alert-secondary'"
                class="table-cell">{{task.deadLine | date: 'dd/MM/yyyy'}}</small>
                <!--                        <div style="margin-left: 10px;">-->
                @if (!this.user?.roles.includes('DIRECTOR_GENERAL') && (task.status==='ONGOING'|| task.status==='DRAFT')) {
                  <button
                    class="btn btn-outline-primary"
                    (click)="openModalDeadline(templateDeadline, task.key, 'SUSPEND_DEADLINE')">{{'CONTROL-MODULE.SUSPEND_DEADLINE'
                  | translate}}</button>
                }
                @if (task.status==='SUSPEND_REQUEST' && this.user?.roles.includes('DIRECTOR_GENERAL')) {
                  <button
                    class="btn btn-outline-primary"
                    (click)="openModalDeadline(templateDeadline, task.key, 'SUSPEND_DEADLINE_RESPONSE')">{{'CONTROL-MODULE.CONFIRM_REJECT_EXTENTION'
                  | translate}}</button>
                }
                @if (task.status==='SUSPENDED') {
                  <button class="btn btn-outline-primary"
                    (click)="openModalDeadline(templateDeadline, task.key, 'REACTIVATE_DEADLINE')">{{'CONTROL-MODULE.REACTIVATE_DEADLINE'
                  | translate}}</button>
                }
              <!--                        </div>-->
            </div>
          }
        </div>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div style="display: flex; flex-direction: column;">
              <div style="width: 100%;">
                <button class="btn btn-outline-primary me-2" style="float: right;"
                (click)="exportTask(task)">{{'CONTROL-MODULE.EXPORT_TASK' | translate}}</button>
              </div>
              @for (item of task.items; track item; let index = $index) {
                <app-action-element [item]="item" [itemIndex]="index"
                  [taskKey]="task.key" [processId]="process.id" [createDate]="process.createDate" (onTaskContentChange)="contentChanged($event)">
                </app-action-element>
              }
              <div class="container-fluid d-flex justify-content-end mt-3">
                @if ((this.user && isStatusOk(this.user.roles, task, 'SAVE')) || isSavable(this.user, task)) {
                  <button class="btn btn-outline-primary me-2"
                  (click)="saveTask(task.key)" [disabled]="missingMandatories(task)">Save</button>
                }
                @if (this.user && isStatusOk(this.user.roles, task, 'SUBMIT') && task.status!=='SUSPENDED') {
                  <button class="btn btn-outline-primary me-2"
                  (click)="openModal(template, task.key, 'SUBMIT')" [disabled]="missingMandatories(task)">Submit</button>
                }
                @if (this.user && isStatusOk(this.user.roles, task, 'VALIDATE') && task.status!=='SUSPENDED') {
                  <button class="btn btn-outline-primary me-2"
                  (click)="openModal(template, task.key, 'VALIDATE')" [disabled]="missingMandatories(task)">Validate</button>
                }
                @if (this.user && isStatusOk(this.user.roles, task, 'APPROVE')  && task.status!=='SUSPENDED') {
                  <button class="btn btn-outline-primary me-2"
                  (click)="openModal(template, task.key, 'APPROVE')">Approve</button>
                }
                @if (this.user && isStatusOk(this.user.roles, task, 'REJECT')  && task.status!=='SUSPENDED') {
                  <button class="btn btn-outline-primary"
                  (click)="openModal(template, task.key, 'REJECT')">Reject</button>
                }
              </div>
              <div class="d-flex">
                <app-comments style="width: 80%; float: left;" (onAddComment)="comment($event,task.key)"
                  (onDeleteComment)="deleteComment($event, task.key)" [comments]="task.comments">
                </app-comments>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>
<ng-template #template>
  <div class="modal-body text-center">
    <p>{{'CONTROL-MODULE.'+actionText | translate}}</p>
    <button type="button" class="btn btn-outline-secondary" (click)="confirm()">{{'CONTROL-MODULE.YES' |
    translate}}</button>
    <button type="button" class="btn btn-primary" (click)="modalRef?.hide()">{{'CONTROL-MODULE.CANCEL' |
    translate}}</button>
  </div>
</ng-template>
<ng-template #templateDeadline>
  <div class="modal-body text-center">
    <p>{{'CONTROL-MODULE.'+actionText | translate}}</p>
    @if (actionText==='SUSPEND_DAYS') {
      <div class="form-group" style="margin-top: 10px;">
        <input type="number" class="form-control" #days [(ngModel)]="deadlineDays" min="1" step="1" required>
      </div>
    }
    @if (actionText==='SUSPEND_DAYS') {
      <button type="button" class="btn btn-outline-secondary" [disabled]="!deadlineDays"
        (click)="requestDeadlineExtention()">{{'CONTROL-MODULE.OK' |
      translate}}</button>
    }
    @if (actionText==='SUSPEND_DAYS') {
      <button type="button" class="btn btn-primary" (click)="modalDeadlineRef?.hide()"
      >{{'CONTROL-MODULE.CANCEL' | translate}}</button>
    }

    @if (actionText==='SUSPEND_DEADLINE_RESPONSE') {
      <button type="button" class="btn btn-outline-secondary"
      (click)="alterDeadlineExtention(true)">{{'CONTROL-MODULE.CONFIRM' | translate}}</button>
    }
    @if (actionText==='SUSPEND_DEADLINE_RESPONSE') {
      <button type="button" class="btn btn-outline-secondary"
      (click)="alterDeadlineExtention(false)">{{'CONTROL-MODULE.REJECT' | translate}}</button>
    }


  </div>
</ng-template>

<ng-template #templateTeam>
  <div class="modal-body text-center">
    <p>{{'CONTROL-MODULE.'+actionText | translate}}</p>
    <div class="form-group" style="margin-top: 10px;">
      <ntr-multiple-select #usersListSelect [items]="userList" [key]="'username'" [placeholder]="'User(s)'"
      [display]="'username'" [activeItems]="process.assignees"></ntr-multiple-select>
    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="confirmTeam(usersListSelect)">{{'CONTROL-MODULE.YES'
    | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="modalTeamRef?.hide()">{{'CONTROL-MODULE.CANCEL' |
    translate}}</button>
  </div>
</ng-template>
</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
